import {useRouter} from 'next/router';

const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL

export function useCanonical() {
    const router = useRouter()
    return SITE_URL + (router.asPath === '/' ? '' : router.asPath).split('?')[0]
}
